<template>
  <div>
    <filter-toolbar
      :hasChanges="hasChanges"
      :appliedFilters="appliedFilters"
      @search="search"
      @update="update"
      @clear="clear">
      <facet-filter
        v-model="filters.facets.status"
        :filter="filterOptions.status"
        @input="change"
      />
    </filter-toolbar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { status } from '../../filters.js'
import FacetFilter from '@/components/Filters/FacetFilter'
import FilterToolbar from '@/components/Filters/FilterToolbar'

export default {
  components: {
    FacetFilter,
    FilterToolbar
  },
  data () {
    return {
      hasChanges: false,
      filters: null,
      // filters
      filterOptions: {
        status: status
      }
    }
  },
  computed: {
    ...mapGetters(['context'])
  },
  methods: {
    change () {
      this.hasChanges = true
    },
    search (searchQuery) {
      this.filters.search = {
        parameter: 'search',
        query: searchQuery
      }
      this.$emit('filter', this.filters)
    },
    update () {
      this.hasChanges = false
      this.filters.preset = 'custom'
      this.$emit('filter', this.filters)
    },
    clear () {
      this.filters = {
        preset: 'all',
        facets: {},
        search: {},
        timestamps: {}
      }
      this.$emit('filter', this.filters)
    }
  },
  props: {
    appliedFilters: {
      type: Object,
      required: true
    }
  },
  watch: {
    appliedFilters: {
      deep: true,
      immediate: true,
      handler (filters) {
        this.filters = filters
      }
    }
  }
}
</script>
